export default __webpack_public_path__ + "static/media/enderima7.59e5fad6.jpg";